module.exports = {
  INSIGHTS_GENERAL: "INSIGHTS_GENERAL",
  INSIGHTS_REFILL_DATES: "INSIGHT_REFILL_DATES",
  INSIGHTS_PLD: "INSIGHTS_PLD",
  INSIGHTS_ACTIVE_HFBS: "INSIGHTS_ACTIVE_HFBS",
  INSIGHTS_HOME_PAGE: "INSIGHTS_HOME_PAGE",
  PRODUCT_REFILLS_BY_LOCATION: "PRODUCT_REFILLS_BY_LOCATION",
};
